import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import { Helpers } from '../../../../helpers/Helpers';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { RootState } from '../../../../redux/store';
import TableFooter from '../../../../components/TableFooter';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../../components/RefreshButton';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { useSortableColumns } from '../../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../../models/common/ColumnFilterModel';
import { sayiYaz } from '../../../../helpers/yakitHesap';
import { AKTARIM_HATA_DURUM, hataDurumRozeti, islemSonucuOzeti, kaynakRozeti } from '../../../../helpers/yakitAktarim';
import { ilkYakitListIstegi, YAKIT_SAYFASI, YakitAktarimHatasi, YakitHataIslemSonucu, YakitListIstegi, YakitService } from '../../../../services/YakitService';
import HataDuzeltModal from './Components/HataDuzeltModal';

/**
 * Genel Giderler > Yakıt Kayıtları > Aktarım Hataları (04.11.2026, #547). Petrol Ofisi'nden çekilen ya da Excel'den
 * aktarılan, fişe dönüşemeyen satışlar. Standart liste (arama kutusu yok, kolon filtresi, kolon seçici, Excel, seçim,
 * sayfalama); varsayılan sıra sunucudan (bekleyenler üstte). Yetki: Yakıt Kayıtları menüsü.
 * A1 Açılış: Yakit/AktarimHatalari (yakıt listesiyle aynı istek biçimi); durum renkli etiket.
 * R1 Düzelt (tek seçili, Bekliyor; ya da satıra çift tıklama) → pencere: araç (zorunlu) + yakıt türü → Yakit/HataDuzelt.
 * R2 Yeniden İşle (seçili bekleyenler) → Yakit/HataYenidenIsle → "N düzeltildi, M hâlâ hatalı" (+ hatalar penceresi).
 * R3 Yok Say (seçili bekleyenler, onay sorusu) → Yakit/HataYokSay.
 */
const YakitHatalar = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = YAKIT_SAYFASI
    const sayfaAnahtari = pageName + " > Aktarım Hataları";
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    // Düzeltme fiş oluşturur / hatanın durumunu değiştirir: ekleme ya da güncelleme yetkisi gerekir.
    const islemYapabilir = !!(menu?.canInsert || menu?.canUpdate);

    const [data, setData] = useState<{ list: YakitAktarimHatasi[], totalRecordCount: number }>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<YakitListIstegi>(ilkYakitListIstegi)
    const [duzeltilecek, setDuzeltilecek] = useState<YakitAktarimHatasi | undefined>(undefined);
    const [sonuc, setSonuc] = useState<YakitHataIslemSonucu | undefined>(undefined);

    const getColumns = () => {
        var str = localStorage.getItem(sayfaAnahtari + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Durum', name: 'durumAdi', order: 0, isVisible: true },
            { title: 'Kaynak', name: 'kaynakAdi', order: 0, isVisible: true },
            { title: 'İşlem Tarihi', name: 'islemTarihiStr', order: 0, isVisible: true },
            { title: 'Saat', name: 'islemSaati', order: 0, isVisible: true },
            { title: 'Plaka', name: 'plaka', order: 0, isVisible: true },
            { title: 'UTTS No', name: 'uttsNo', order: 0, isVisible: true },
            { title: 'Ürün', name: 'yakitTuru', order: 0, isVisible: true },
            { title: 'Litre', name: 'miktar', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Tutar', name: 'brut', order: 0, isVisible: true, className: 'text-end' },
            { title: 'Hata', name: 'hata', order: 0, isVisible: true },
            { title: 'İstasyon / Açıklama', name: 'aciklama', order: 0, isVisible: true },
            { title: 'İşlem No', name: 'hariciIslemNo', order: 0, isVisible: false },
            { title: 'Oluşturma', name: 'olusturmaStr', order: 0, isVisible: false }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: YakitListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await YakitService.aktarimHatalari(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const secili = data.list.filter(x => x.isSelected);
    const seciliBekleyen = secili.filter(x => x.durum == AKTARIM_HATA_DURUM.BEKLIYOR);

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.id == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const duzeltAc = (item: YakitAktarimHatasi | undefined = undefined) => {
        const h = item ?? (secili.length == 1 ? secili[0] : undefined);

        if (!h || !islemYapabilir || h.durum != AKTARIM_HATA_DURUM.BEKLIYOR)
            return;

        setDuzeltilecek(h);
    }

    const yenidenIsle = async () => {
        if (seciliBekleyen.length == 0)
            return;
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.hataYenidenIsle(seciliBekleyen.map(x => x.id));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            const s = response.data as YakitHataIslemSonucu;

            // Hata ayrıntısı varsa pencerede listelenir; yoksa yalnız özet toast.
            if (s.hatalar && s.hatalar.length > 0)
                setSonuc(s);
            else if (s.kalan > 0)
                toast.error(islemSonucuOzeti(s));
            else
                toast.success(islemSonucuOzeti(s));

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const yokSay = async () => {
        const ids = data.list.filter(x => x.isSelected && x.durum == AKTARIM_HATA_DURUM.BEKLIYOR).map(x => x.id);
        if (ids.length == 0)
            return;
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.hataYokSay(ids);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(`${response.data ?? ids.length} kayıt yok sayıldı.`)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YakitService.aktarimHatalariExport(buildExcelRequest(filter, mode, secili.map(x => x.id), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon adları backend'deki eşlemeyle (AktarimHatalari) aynı.
    const sortableColumns = ['kaynakAdi', 'islemTarihiStr', 'islemSaati', 'plaka', 'uttsNo', 'yakitTuru', 'miktar', 'brut', 'aciklama', 'hata', 'durumAdi', 'hariciIslemNo', 'olusturmaStr'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Hata satırındaki plaka araç kartında olmayabilir; bu yüzden plaka metin filtresi (yakıt listesindeki seçim değil).
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        kaynakAdi: { type: 'text' },
        islemTarihiStr: { type: 'date' },
        islemSaati: { type: 'text' },
        plaka: { type: 'text' },
        uttsNo: { type: 'text' },
        yakitTuru: { type: 'text' },
        miktar: { type: 'number' },
        brut: { type: 'number' },
        aciklama: { type: 'text' },
        hata: { type: 'text' },
        durumAdi: { type: 'text' },
        hariciIslemNo: { type: 'text' },
        olusturmaStr: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: YakitAktarimHatasi, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger: any = item2[column];

        if (column == 'durumAdi')
            deger = <span className={hataDurumRozeti(item.durum)}>{item.durumAdi}</span>;
        else if (column == 'kaynakAdi')
            deger = deger ? <span className={kaynakRozeti(item.kaynak, item.kaynakAdi)}>{deger}</span> : '';
        else if (column == 'miktar' || column == 'brut')
            deger = deger == null ? '' : sayiYaz(deger);
        else if (column == 'hata')
            deger = deger ? <span className={item.durum == AKTARIM_HATA_DURUM.BEKLIYOR ? 'text-danger' : 'text-muted'}>{deger}</span> : '';

        return <td className={className} onClick={() => setItemSelected(item.id)} onDoubleClick={() => duzeltAc(item)}>{deger}</td>;
    }

    const tekSeciliBekliyor = secili.length == 1 && secili[0].durum == AKTARIM_HATA_DURUM.BEKLIYOR;

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <div style={{ flex: 1 }}></div>

                {
                    islemYapabilir && (
                        <React.Fragment>
                            <button id='yakit-hata-duzelt' disabled={!tekSeciliBekliyor} onClick={() => duzeltAc()} className='btn btn-sm btn-flex btn-info' title='Tek bir bekleyen satır seçin'>
                                <i className='fa fa-wrench fs-6 me-1' />
                                Düzelt
                            </button>

                            <button id='yakit-hata-yeniden-isle' disabled={seciliBekleyen.length == 0} onClick={yenidenIsle} className='btn btn-sm btn-flex btn-light-primary' title='Seçili bekleyen satırları araç kartlarındaki güncel bilgilerle yeniden dener'>
                                <i className='fa fa-rotate fs-6 me-1' />
                                Yeniden İşle
                            </button>

                            <button id='yakit-hata-yok-say' disabled={seciliBekleyen.length == 0} onClick={() => dispatch(storeAreYouSureModalCallback(yokSay))} className='btn btn-sm btn-flex btn-light-danger'>
                                <i className='fa fa-ban fs-6 me-1' />
                                Yok Say
                            </button>
                        </React.Fragment>
                    )
                }

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={sayfaAnahtari} pageVersion={pageVersion} setColumns={setColumns} />

                <ExcelExportMenu pageName={pageName} selectedCount={secili.length} onExport={excelExport} />

                <div className='m-0'>
                    <a id='yakit-hata-geri' onClick={() => navigate('/yakit/list')} className='btn btn-sm fw-bold btn-light-primary'>
                        <i className='fa fa-arrow-left fs-6 me-1' />
                        Yakıt Kayıtları
                    </a>
                </div>
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName + ' > ',
                isActive: false,
                path: ''
            }]}>Aktarım Hataları</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.id} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.id)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={secili.length}
                    />
                </KTCard>
            </Content>

            <HataDuzeltModal
                hata={duzeltilecek}
                onClose={() => setDuzeltilecek(undefined)}
                onDuzeltildi={() => { setDuzeltilecek(undefined); getData(); }}
            />

            <Modal show={!!sonuc} onHide={() => setSonuc(undefined)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Yeniden işleme sonucu</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        sonuc && (
                            <React.Fragment>
                                <div className={'fw-bold fs-6 mb-3 ' + (sonuc.kalan > 0 ? 'text-danger' : 'text-success')}>{islemSonucuOzeti(sonuc)}</div>
                                <ul className='mb-0 ps-5 fs-7 text-gray-700'>
                                    {sonuc.hatalar.map((h, i) => <li key={i}>{h}</li>)}
                                </ul>
                            </React.Fragment>
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-sm btn-light' onClick={() => setSonuc(undefined)}>Kapat</button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default YakitHatalar;
